"use client";

import { registerRouteChangeListener } from '@/utils/routeEvents';
import { type ReactNode, useEffect, useState } from "react";


export default function PageLoadingIndicator() {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        registerRouteChangeListener("start", () => {
            setIsLoading(true);
        });

        registerRouteChangeListener("completed", () => {
            setIsLoading(false);
        });
    }, []);

    return (
        <>
            {isLoading && (
                <div className="fixed rop-0 z-[2000] left-0 h-1 w-screen  ">
                    <div className={"h-full  w-full loader absolute rounded-full bg-primary-600"}></div>
                </div>
            )}
        </>
    );
}